/*! tailwindcss v4.3.3 | MIT License | https://tailwindcss.com */
.spinner {
  display: flex;
  flex-direction: column;
  align-items: center;
}
